import GenieLoader from "@/components/ui/GenieLoader";

interface RedirectingScreenProps {
  /** @deprecated Brand colour is now standardised inside GenieLoader. */
  brandColor?: string;
  message?: string;
}

const RedirectingScreen = ({ message = "Redirecting…" }: RedirectingScreenProps) => (
  <GenieLoader size="fullscreen" loadingText={message} />
);

export default RedirectingScreen;
